import React, { Component } from 'react'
import './style.css'

export default class AppList extends Component {
  render() {
    return (
      <div className="flex flex-column">
        <div className="mobile-nav">
          <a className="mobile-logo ml3" href="/shop/icons">Veil - Icon List</a>
        </div>
        <div className="nav">
          <a className="nav-link" href="/shop/icons#overview">Overview</a>
          <a className="nav-link" href="/shop/icons#colors">Colors</a>
          <a className="nav-link" href="/shop/icons#tutorial">Tutorial</a>
          <a className="nav-link" href="/shop/icons#faq">FAQ</a>
          <a className="nav-link" href="/shop/icons/list">Icon List</a>
        </div>
        <a className="buy-button" href="https://gum.co/antebellum"  onClick={() => {window.fbq('track', 'InitiateCheckout');}}>Purchase - $18</a>
          <div className="w-100 mw-100 flex flex-row justify-center mt5 landing-top-space mb5">
            <div className="w-10"></div>
            <div className="w-80 child flex flex-column app-list mt5">
              <div className="list-section-head">
                #
              </div>
              <ul>
                <li>	9gag	</li>
              </ul>
              <div className="list-section-head">
                A
              </div>
              <ul>
                <li>	Acrobat	</li>
                <li>	Activity	</li>
                <li>	Address	</li>
                <li>	Airbnb	</li>
                <li>	Amazon	</li>
                <li>	Among Us	</li>
                <li>	App Store	</li>
                <li>	Aperture	</li>
                <li>	Apple	</li>
                <li>	Apple TV	</li>
                <li>	Audible	</li>
              </ul>
              <div className="list-section-head">
                B
              </div>
              <ul>
                <li>	Bank	</li>
                <li>	BCA	</li>
                <li>	Bible	</li>
                <li>	Bolt	</li>
                <li>	Bookmark	</li>
                <li>	Box	</li>
                <li>	Browser	</li>
              </ul>
              <div className="list-section-head">
                C
              </div>
              <ul>
                <li>	Calculator	</li>
                <li>	Calendar	</li>
                <li>	Camera	</li>
                <li>	Chat	</li>
                <li>	Chrome	</li>
                <li>	Clock	</li>
                <li>	Command	</li>
                <li>	Contacts	</li>
                <li>	Credit Card	</li>
                <li>	Crunchyroll	</li>

              </ul>
              <div className="list-section-head">
                D
              </div>
              <ul>
                <li>	Discord	</li>
                <li>	Disney Plus	</li>
                <li>	Doctor	</li>
                <li>	Dropbox	</li>
              </ul>
              <div className="list-section-head">
                F
              </div>
              <ul>
                <li>	Facebook	</li>
                <li>	FaceTime	</li>
                <li>	Figma	</li>
                <li>	Firefox	</li>
                <li>	Flash Light	</li>
                <li>	Folder	</li>
                <li>	Framer	</li>
              </ul>
              <div className="list-section-head">
                G
              </div>
              <ul>
                <li>	G. Analytics	</li>
                <li>	G. Drive	</li>
                <li>	G. Maps	</li>
                <li>	G. Photos	</li>
                <li>	Gear	</li>
                <li>	Github	</li>
                <li>	Gmail	</li>
                <li>	Google	</li>
                <li>	Grid	</li>
              </ul>
              <div className="list-section-head">
                H
              </div>
              <ul>
                <li>	Hashtags	</li>
                <li>	Health	</li>
                <li>	House	</li>
              </ul>
              <div className="list-section-head">
                I
              </div>
              <ul>
              <li>	Instagram	</li>
              </ul>
              <div className="list-section-head">
                L
              </div>
              <ul>
                <li>	LastPass	</li>
                <li>	Lifx	</li>
                <li>	Light Room	</li>
                <li>	Line	</li>
                <li>	LinkedIn	</li>
              </ul>
              <div className="list-section-head">
                M
              </div>
              <ul>
                <li>	M. Teams	</li>
                <li>	Mail	</li>
                <li>	Maps	</li>
                <li>	Menu	</li>
                <li>	Messages	</li>
                <li>	Messenger	</li>
                <li>	Money	</li>
                <li>	Monzo	</li>
                <li>	Music	</li>
              </ul>
              <div className="list-section-head">
                N
              </div>
              <ul>
                <li>	Neflix	</li>
                <li>	News	</li>
                <li>	Nike	</li>
                <li>	Notes	</li>
              </ul>
              <div className="list-section-head">
                O
              </div>
              <ul>
                <li>	Outlook	</li>
                <li>	Overcast	</li>
              </ul>
              <div className="list-section-head">
                P
              </div>
              <ul>
                <li>	Passwords	</li>
                <li>	Paypal	</li>
                <li>	Phone	</li>
                <li>	Photos	</li>
                <li>	Pinterest	</li>
                <li>	Playstation	</li>
                <li>	Plus	</li>
                <li>	Podcasts	</li>
                <li>	Pods	</li>
              </ul>
              <div className="list-section-head">
                Q
              </div>
              <ul>
                <li>	QR Code	</li>
              </ul>
              <div className="list-section-head">
                R
              </div>
              <ul>
                <li>	Reddit	</li>
                <li>	Reminders	</li>
                <li>	Robinhood	</li>
              </ul>
              <div className="list-section-head">
                S
              </div>
              <ul>
                <li>	Settings	</li>
                <li>	Shazam	</li>
                <li>	Shield	</li>
                <li>	Shopify	</li>
                <li>	Shortcuts	</li>
                <li>	Slack	</li>
                <li>	Snapchat	</li>
                <li>	Soundcloud	</li>
                <li>	Spotify	</li>
                <li>	Stack	</li>
                <li>	Steam	</li>
                <li>	Sticker	</li>
                <li>	Stocks	</li>
              </ul>
              <ul>
                <li>	Telegram	</li>
                <li>	Tesla	</li>
                <li>	Tidal	</li>
                <li>	Tik Tok	</li>
                <li>	Tokopedia	</li>
                <li>	Translate	</li>
                <li>	Trello	</li>
                <li>	Tumblr	</li>
                <li>	Twitch	</li>
                <li>	Twitter	</li>
              </ul>
              <div className="list-section-head">
                U
              </div>
              <ul>
                <li>	Unfold	</li>
              </ul>
              <div className="list-section-head">
                V
              </div>
              <ul>
                <li>	Venmo	</li>
                <li>	View Finder	</li>
                <li>	Vsco	</li>
              </ul>
              <div className="list-section-head">
                W
              </div>
              <ul>
                <li>	Wallet	</li>
                <li>	Watch	</li>
                <li>	Waze	</li>
                <li>	Weather	</li>
                <li>	Whatsapp	</li>
              </ul>
              <div className="list-section-head">
                X
              </div>
              <ul>
                <li>	XBox	</li>
              </ul>
              <div className="list-section-head">
                Y
              </div>
              <ul>
                <li>	Youtube	</li>
              </ul>
              <div className="list-section-head">
                Z
              </div>
              <ul>
                <li>	ZenGo	</li>
                <li>	Zoom	</li>
              </ul>

              <div className="bottom-nav flex flex-column mb5 mt5">
                <a className="botton-nav-link pa0 ma0 pb3" href="/shop/icons#overview">Overview</a>
                <a className="botton-nav-link pa0 ma0 pb3" href="/shop/icons#colors">Colors</a>
                <a className="botton-nav-link pa0 ma0 pb3" href="/shop/icons#tutorial">Tutorial</a>
                <a className="botton-nav-link pa0 ma0 pb3" href="/shop/icons#faq">FAQ</a>
              </div>
            </div>
            <div className="w-10"></div>
          </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Shop/IosIcon/AppList/index.jsx